<template>
	<v-layout row wrap class="mb-5">
		<v-flex sm12 md6>
			<p class="add-event-step-header">Where is this space?</p>
			<google-map
				styleProp='{
					height: 400px,
					width: 100%,
				}'
				:mapcenter='mapcenter'
				:zoom='mapzoom'
				:radius='radius'>
			</google-map>
			<google-maps-autocomplete
				class="mt-3"
				@place_changed="setPlace"
            />
			<v-text-field v-model="neighborhood" label="Neighborhood"></v-text-field>
			<v-checkbox color="link" v-model="apartmentCheck" hide-details class="mt-2" label="This is an apartment" placeholder="Enter the location neighborhood"></v-checkbox>
			<v-text-field
				class="mt-1"
				v-if="apartmentCheck"
				v-model="apartmentNumber"
				label="Apartment or Room Number"
				placeholder="Enter your apartment/room number"
			></v-text-field>
		</v-flex>
		<v-flex xs12 md4 offset-md1 hidden-sm-and-down class="pt-3">
			<v-card class="add-event-tip-box">
				<v-card-text class="p-relative pt-5">
					<div class="info-trapezoid p-absolute">
						<div class="info-content">
							<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
						</div>
					</div>
					<p class="add-event-tip-content"><strong>Note:</strong> This address won't be shown to anyone, unless you approve their request to attend your event.</p>
					<p class="add-event-tip-content">Only the city, state, and neighborhood will be shown on the map (as a radius around the general area of your location).</p>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-dialog scrollable v-model="infoDialog">
			<v-card style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
				</v-card-title>
				<v-card-text style="max-height:50vh;">
					<p class="add-event-tip-content"><strong>Note:</strong> This address won't be shown to anyone, unless you approve their request to attend your event.</p>
					<p class="add-event-tip-content">Only the city, state, and neighborhood will be shown on the map (as a radius around the general area of your location).</p>
				</v-card-text>
				<v-card-actions>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { deepCopy, compare } from '~/store/util/util'
import GoogleMapsAutocomplete from '~/components/GoogleMapsAutocomplete'
import GoogleMap from '~/components/GoogleMap'
export default {
	data() {
		return {
			neighborhood: '',
			exampleOpen: false,
			location: {
				address1: '',
				address2: '',
				city: '',
				state: '',
				country: '',
				zip_code: '',
				name: '',
				description: '',
				locationrules: '',
				image: '',
				locationtype: ''
			},
			mapcenter: {
				lat: 34.006933,
				lng: -118.35
			},
			mapzoom: 9,
			markers: [],
			place: null,
			preAddress: null,
			mapRadius: 350
		}
	},
	components: {
		GoogleMapsAutocomplete: GoogleMapsAutocomplete,
		GoogleMap: GoogleMap
	},
	beforeRouteLeave(to, from, next) {
		if (
			![
				this.getAddLocationProp('latitude'),
				this.getAddLocationProp('longitude'),
				this.getAddLocationProp('privateAddress'),
				this.getAddLocationProp('publicAddress')
			].includes(null) &&
			!(
				this.getAddLocationProp('apartmentCheck') === true &&
				this.getAddLocationProp('apartmentNumber') === null
			)
		) {
			this.setAddLocationValidStep(from.path)
			this.removeAddLocationInvalidStep(from.path)
		} else {
			this.removeAddLocationValidStep(from.path)
			this.setAddLocationInvalidStep(from.path)
		}
		next()
	},
	mounted() {
		// if (!([this.getAddLocationProp('latitude'), this.getAddLocationProp('longitude')].includes(null))) {
		// 	this.mapcenter = {
		// 		lat: this.getAddLocationProp('latitude'),
		// 		lng: this.getAddLocationProp('longitude')
		// 	}
		// 	this.place = 'nothing'
		// 	this.mapzoom = 15
		// 	this.prefillAddress = this.getAddLocationProp('privateAddress')
		// 	console.log('asdf')
		// } else {
		// 	console.log(this.getHost)
		// 	this.prefillAddress = this.getHost.address
		// 	console.log(this.prefillAddress)
		// }
	},
	methods: {
		...mapActions([
			'setAddLocationProp',
			'setAddLocationValidStep',
			'removeAddLocationValidStep',
			'setAddLocationInvalidStep',
			'removeAddLocationInvalidStep'
		]),
        getPrefillAddress() {
			if (
				![
					this.getAddLocationProp('latitude'),
					this.getAddLocationProp('longitude')
				].includes(null)
			) {
				this.mapcenter = {
					lat: this.getAddLocationProp('latitude'),
					lng: this.getAddLocationProp('longitude')
				}
				this.place = 'nothing'
				this.mapzoom = 15
				return this.getAddLocationProp('privateAddress')
			} else {
				// prefill from host address
				this.place = 'nothing'
				this.mapzoom = 15
				if (this.getHost.hasOwnProperty('new_address')) {
					if (this.getHost.new_address.hasOwnProperty('apartmentNumber')) {
						this.apartmentCheck = true
						this.apartmentNumber = this.getHost.new_address.apartmentNumber
					}
				}
				return this.hostLocationShort
			}
		},
		setPlace(place) {
			this.neighborhood = ''
			this.place = place
			this.mapcenter = {
				lat: place.geometry.location.lat(),
				lng: place.geometry.location.lng()
			}
			this.mapzoom = 15
			let publicLocationString = ''
			let address = deepCopy(this.getAddLocationProp('address')) || {}
			if (address === null) {
				address = {}
			}
			let components = place.address_components
			console.log(components)
			console.log(address)
			for (var i = 0; i < components.length; i++) {
				// JSON Method
				let type = components[i].types[0]
				if (type === 'street_number') {
					address['street_number'] = components[i].long_name
				} else if (type === 'route') {
					address['route'] = components[i].long_name
				} else if (type === 'neighborhood') {
					this.neighborhood = components[i].long_name
					address['neighborhood'] = components[i].long_name
				} else if (type === 'locality') {
					address['city'] = components[i].long_name
				} else if (type === 'administrative_area_level_2') {
					address['county'] = components[i].long_name
				} else if (type === 'administrative_area_level_1') {
					address['state'] = components[i].long_name
					address['state_short'] = components[i].short_name
				} else if (type === 'country') {
					address['country'] = components[i].long_name
					address['country_short'] = components[i].short_name
				} else if (type === 'postal_code') {
					address['zipcode'] = components[i].long_name
				}

				// Old method
				if (components[i].types.includes('neighborhood')) {
					publicLocationString += components[i].long_name + ', '
				} else if (components[i].types.includes('locality')) {
					publicLocationString += components[i].long_name + ', '
				} else if (
					components[i].types.includes('administrative_area_level_1')
				) {
					publicLocationString += components[i].short_name + ', '
				} else if (components[i].types.includes('country')) {
					publicLocationString += components[i].short_name
				}
			}
			address.private_latitude = this.mapcenter.lat
			address.private_longitude = this.mapcenter.lng

			if (this.getAddLocationProp('address') !== null) {
				if (!compare(this.getAddLocationProp('address'), address)) {
					this.apartmentCheck = false
					this.apartmentNumber = ''
				}
			}

			this.setAddLocationProp({
				prop: 'latitude',
				value: this.mapcenter.lat
			})
			this.setAddLocationProp({
				prop: 'longitude',
				value: this.mapcenter.lng
			})
			this.setAddLocationProp({
				prop: 'privateAddress',
				value: place.formatted_address
			})
			this.setAddLocationProp({
				prop: 'publicAddress',
				value: publicLocationString
			})
			this.setAddLocationProp({
				prop: 'address',
				value: address
			})

			// google.maps.event.trigger(map, 'resize')
		}
	},
	watch: {
		neighborhood(value) {
			let temp = deepCopy(this.getAddLocationProp('address'))
			if (temp !== null && temp.hasOwnProperty('neighborhood')) {
				temp['neighborhood'] = value
			}
			this.setAddLocationProp({
				prop: 'address',
				value: temp
			})
		},
	},
	computed: {
		...mapGetters(['getAddLocationProp', 'getHost']),
		getmapcenter() {
			return this.mapcenter
		},
		getAddress() {
			return this.getAddLocationProp('privateAddress')
		},
		markerPosition() {
			return { lat: this.mapcenter.lat, lng: this.mapcenter.lng }
		},
		infoDialog: {
			get() {
				return this.getAddLocationProp('infoDialog')
			},
			set(val) {
				this.setAddLocationProp({ prop: 'infoDialog', value: val })
			}
		},
		apartmentNumber: {
			get() {
				return this.getAddLocationProp('apartmentNumber')
			},
			set(val) {
				this.setAddLocationProp({
					prop: 'apartmentNumber',
					value: val
				})
			}
		},
		apartmentCheck: {
			get() {
				return this.getAddLocationProp('apartmentCheck')
			},
			set(val) {
				this.setAddLocationProp({
					prop: 'apartmentCheck',
					value: val
				})
			}
		},
		lat: {
			get() {
				return this.mapcenter.lat
			},
			set(val) {
				this.mapcenter.lat = val
			},
			deep: true
		},
		lng: {
			get() {
				return this.mapcenter.lng
			},
			set(val) {
				this.mapcenter.lng = val
			},
			deep: true
		},
		zoom: {
			get() {
				return this.mapzoom
			},
			set(val) {
				this.mapzoom = val
			},
			deep: true
		},
		radius: {
			get() {
				return this.mapRadius
			},
			set(val) {
				this.mapRadius = val
			}
		},
		hostLocationShort() {
			let locationString = ''
			if (this.getHost.hasOwnProperty('new_address')) {
				let addressComponents = []
				if (this.getHost.new_address.hasOwnProperty('street_number')) {
					if (this.getHost.new_address.hasOwnProperty('route')) {
						addressComponents.push(
							this.getHost.new_address.street_number +
								' ' +
								this.getHost.new_address.route
						)
					}
				}
				if (this.getHost.new_address.hasOwnProperty('city')) {
					addressComponents.push(this.getHost.new_address.city)
				}
				if (this.getHost.new_address.hasOwnProperty('country')) {
					if (this.getHost.new_address.country !== 'United States') {
						addressComponents.push(this.getHost.new_address.country)
					}
				}
				for (var i = 0; i < addressComponents.length; i++) {
					locationString += addressComponents[i]
					if (i < addressComponents.length - 1) {
						locationString += ', '
					}
				}
			}
			return locationString
		}
	}
}
</script>

<style>
.gmapauto {
	width: 100%;
}
</style>
